export default "__VITE_ASSET__C8NfM7_l__"